/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['assets/js/modules/pricing/pricingModel', 'assets/js/modules/pricing/surchargePricingModel', 'assets/js/modules/utils'], function(
    PricingModel,
    SurchargePricingModel,
    utils
) {
    return PricingModel.extend(
        {
            defaults: {
                strategy: 'percentage',
                percentage: 0,
                basedOn: 'retail_price'
            },
            /**
             * @param {Object} context
             * @returns {number}
             */
            getPrice: function(context) {
                const pricingSetName = this.get('basedOn') !== 'retail_price' ? context.pricingSetName : null;
                var sku = context.sku;
                var selectedOptionValues = context.selectedOptionValues;
                var skuRetailCost = sku.getPrice(pricingSetName);

                //only apply discount for non-booklet substrate option
                if (context.isNonBookletSubstrate) {
                    skuRetailCost = sku.getPrice(pricingSetName);
                }

                // thickness option price needs to be based on sku + material
                selectedOptionValues.forEach(function(optionValue) {
                    if (optionValue.get('pricing') instanceof SurchargePricingModel) {
                        skuRetailCost += optionValue.get('pricing').getPrice({
                            sku: sku
                        });
                    }
                });

                if (parseFloat(this.get('percentage')) === 1.0) {
                    // Avoid useless rounding issues if the percentage is 100%
                    return utils.roundFloat(skuRetailCost, 2);
                }

                return utils.roundFloat(utils.multiplication(skuRetailCost, this.get('percentage')));
            },

            toString: function(context) {
                return '';
            }
        },
        {
            BASED_ON_RETAIL_PRICE: 'retail_price',
            BASED_ON_USER_PRICE_SET: 'user_price_set',
            BASED_ON_REQUIRED_OPTION_PRICE: 'required_option_price'
        }
    );
});
